import { render, staticRenderFns } from "./GetConsult.vue?vue&type=template&id=c58543c0&"
import script from "./GetConsult.vue?vue&type=script&lang=js&"
export * from "./GetConsult.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports